var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#EEF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10102_14151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6669 19.2802V21.2802C22.6677 21.4659 22.6297 21.6497 22.5553 21.8198C22.4809 21.9899 22.3718 22.1426 22.235 22.2681C22.0982 22.3937 21.9367 22.4892 21.7608 22.5487C21.5849 22.6082 21.3985 22.6303 21.2136 22.6136C19.1622 22.3907 17.1916 21.6897 15.4603 20.5669C13.8495 19.5433 12.4838 18.1777 11.4603 16.5669C10.3336 14.8277 9.63244 12.8476 9.41361 10.7869C9.39695 10.6025 9.41886 10.4167 9.47795 10.2413C9.53703 10.0659 9.63199 9.90469 9.75679 9.76797C9.88159 9.63126 10.0335 9.52203 10.2028 9.44724C10.3721 9.37245 10.5552 9.33374 10.7403 9.33356H12.7403C13.0638 9.33038 13.3775 9.44495 13.6228 9.65592C13.8681 9.86689 14.0283 10.1599 14.0736 10.4802C14.158 11.1203 14.3146 11.7487 14.5403 12.3536C14.63 12.5922 14.6494 12.8515 14.5962 13.1008C14.543 13.3501 14.4195 13.579 14.2403 13.7602L13.3936 14.6069C14.3427 16.2759 15.7246 17.6579 17.3936 18.6069L18.2403 17.7602C18.4215 17.581 18.6504 17.4575 18.8997 17.4043C19.149 17.3511 19.4083 17.3705 19.6469 17.4602C20.2518 17.6859 20.8802 17.8425 21.5203 17.9269C21.8441 17.9726 22.1399 18.1357 22.3513 18.3852C22.5627 18.6348 22.6751 18.9533 22.6669 19.2802Z",
    stroke: "#4F39F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10102_14151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0f1f2845ef194bcafab2065a5d51a0d4.svg";
export { ForwardRef as ReactComponent };